<script>
export default {
    data() {
        return {
            myUrls: {
                eSklepUrl: 'https://braster.eu',
                client_id: 'client',
                client_secret: '123456yU',
                authUrl: 'https://central.braster.eu',
                localUrl: 'https://backend.braster.eu',
            },
        };
    },
};
</script>



// WEBPACK FOOTER //
// config.vue?200d5b8e